// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1d3DO","title":"InfoRow_title__PtAoB"};